export const srcKeys = [
  {
    index: 0,
    style: {
      top: "10.0%",
      left: "2.5%",
    },
  },
  {
    index: 1,
    style: {
      top: "10.0%",
      left: "9.0%",
    },
  },
  {
    index: 2,
    style: {
      top: "10.0%",
      left: "15.5%",
    },
  },
  {
    index: 3,
    style: {
      top: "10.0%",
      left: "22.0%",
    },
  },
  {
    index: 4,
    style: {
      top: "10.0%",
      left: "28.5%",
    },
  },
  {
    index: 5,
    style: {
      top: "10.0%",
      left: "35%",
    },
  },
  {
    index: 6,
    style: {
      top: "10.0%",
      left: "41.5%",
    },
  },
  {
    index: 7,
    style: {
      top: "10.0%",
      left: "48%",
    },
  },
  {
    index: 8,
    style: {
      top: "10.0%",
      left: "54.5%",
    },
  },
  {
    index: 9,
    style: {
      top: "10.0%",
      left: "61%",
    },
  },
  {
    index: 10,
    style: {
      top: "10.0%",
      left: "67.5%",
    },
  },
  {
    index: 11,
    style: {
      top: "10.0%",
      left: "74%",
    },
  },
  {
    index: 12,
    style: {
      top: "10.0%",
      left: "80.5%",
    },
  },
  {
    index: 13,
    style: {
      top: "10.0%",
      left: "87.0%",
    },
  },
  {
    index: 88,
    style: {
      top: "10.0%",
      left: "93.5%",
    },
  },
  {
    index: 25,
    style: {
      top: "26.5%",
      left: "2.5%",
      width: "7.2%",
    },
  },
  {
    index: 26,
    style: {
      top: "26.5%",
      left: "12.2%",
    },
  },
  {
    index: 27,
    style: {
      top: "26.5%",
      left: "18.7%",
    },
  },
  {
    index: 28,
    style: {
      top: "26.5%",
      left: "25.2%",
    },
  },
  {
    index: 29,
    style: {
      top: "26.5%",
      left: "31.7%",
    },
  },
  {
    index: 30,
    style: {
      top: "26.5%",
      left: "38.2%",
    },
  },
  {
    index: 31,
    style: {
      top: "26.5%",
      left: "44.7%",
    },
  },
  {
    index: 32,
    style: {
      top: "26.5%",
      left: "51.2%",
    },
  },
  {
    index: 33,
    style: {
      top: "26.5%",
      left: "57.7%",
    },
  },
  {
    index: 34,
    style: {
      top: "26.5%",
      left: "64.2%",
    },
  },
  {
    index: 35,
    style: {
      top: "26.5%",
      left: "70.7%",
    },
  },
  {
    index: 36,
    style: {
      top: "26.5%",
      left: "77.2%",
    },
  },
  {
    index: 37,
    style: {
      top: "26.5%",
      left: "83.7%",
    },
  },
  {
    index: 38,
    style: {
      top: "26.5%",
      left: "90.2%",
      width: "7.5%",
    },
  },
  {
    index: 50,
    style: {
      top: "42.5%",
      left: "2.5%",
      width: "9.0%",
    },
  },
  {
    index: 51,
    style: {
      top: "42.5%",
      left: "13.8%",
    },
  },
  {
    index: 52,
    style: {
      top: "42.5%",
      left: "20.3%",
    },
  },
  {
    index: 53,
    style: {
      top: "42.5%",
      left: "26.8%",
    },
  },
  {
    index: 54,
    style: {
      top: "42.5%",
      left: "33.3%",
    },
  },
  {
    index: 55,
    style: {
      top: "42.5%",
      left: "39.8%",
    },
  },
  {
    index: 56,
    style: {
      top: "42.5%",
      left: "46.3%",
    },
  },
  {
    index: 57,
    style: {
      top: "42.5%",
      left: "52.8%",
    },
  },
  {
    index: 58,
    style: {
      top: "42.5%",
      left: "59.3%",
    },
  },
  {
    index: 59,
    style: {
      top: "42.5%",
      left: "65.8%",
    },
  },
  {
    index: 60,
    style: {
      top: "42.5%",
      left: "72.3%",
    },
  },
  {
    index: 61,
    style: {
      top: "42.5%",
      left: "78.8%",
    },
  },
  {
    index: 62,
    style: {
      top: "42.5%",
      left: "85.8%",
      width: "11.8%",
    },
  },
  {
    index: 75,
    style: {
      top: "59.8%",
      left: "2.5%",
      width: "12%",
    },
  },
  {
    index: 76,
    style: {
      top: "59.8%",
      left: "17.0%",
    },
  },
  {
    index: 77,
    style: {
      top: "59.8%",
      left: "23.5%",
    },
  },
  {
    index: 78,
    style: {
      top: "59.8%",
      left: "30.0%",
    },
  },
  {
    index: 79,
    style: {
      top: "59.8%",
      left: "36.5%",
    },
  },
  {
    index: 80,
    style: {
      top: "59.8%",
      left: "43.0%",
    },
  },
  {
    index: 81,
    style: {
      top: "59.8%",
      left: "49.5%",
    },
  },
  {
    index: 82,
    style: {
      top: "59.8%",
      left: "56.0%",
    },
  },
  {
    index: 83,
    style: {
      top: "59.8%",
      left: "62.5%",
    },
  },
  {
    index: 84,
    style: {
      top: "59.8%",
      left: "69.0%",
    },
  },
  {
    index: 85,
    style: {
      top: "59.8%",
      left: "75.5%",
    },
  },
  {
    index: 86,
    style: {
      top: "59.8%",
      left: "82.0%",
      width: "9.0%",
    },
  },
  {
    index: 87,
    style: {
      top: "59.8%",
      left: "93.5%",
    },
  },
  {
    index: 100,
    style: {
      top: "76.0%",
      left: "12%",
      width: "4.0%",
    },
  },
  {
    index: 101,
    style: {
      top: "76.0%",
      left: "19.0%",
      width: "7.0%",
    },
  },
  {
    index: 106,
    style: {
      top: "76.0%",
      left: "28.5%",
      width: "43.0%",
    },
  },
  {
    index: 110,
    style: {
      top: "76.0%",
      left: "74.0%",
      width: "7.0%",
    },
  },
  {
    index: 111,
    style: {
      top: "76.0%",
      left: "83.5%",
    },
  },
];

export const dstKeys = {
  "#00070004": {
    text: [{ text: "A", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070005": {
    text: [{ text: "B", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070006": {
    text: [{ text: "C", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070007": {
    text: [{ text: "D", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070008": {
    text: [{ text: "E", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070009": {
    text: [{ text: "F", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000A": {
    text: [{ text: "G", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000B": {
    text: [{ text: "H", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000C": {
    text: [{ text: "I", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000D": {
    text: [{ text: "J", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000E": {
    text: [{ text: "K", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000F": {
    text: [{ text: "L", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070010": {
    text: [{ text: "M", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070011": {
    text: [{ text: "N", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070012": {
    text: [{ text: "O", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070013": {
    text: [{ text: "P", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070014": {
    text: [{ text: "Q", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070015": {
    text: [{ text: "R", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070016": {
    text: [{ text: "S", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070017": {
    text: [{ text: "T", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070018": {
    text: [{ text: "U", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070019": {
    text: [{ text: "V", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001A": {
    text: [{ text: "W", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001B": {
    text: [{ text: "X", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001C": {
    text: [{ text: "Y", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001D": {
    text: [{ text: "Z", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001E": {
    text: [
      { text: "!", style: { top: "30%", fontSize: "1.2em" } },
      { text: "1", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#0007001F": {
    text: [
      { text: "@", style: { top: "25%", fontSize: "1.2em" } },
      { text: "2", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070020": {
    text: [
      { text: "#", style: { top: "30%", fontSize: "1.2em" } },
      { text: "3", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070021": {
    text: [
      { text: "$", style: { top: "30%", fontSize: "1.2em" } },
      { text: "4", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070022": {
    text: [
      { text: "%", style: { top: "30%", fontSize: "1.2em" } },
      { text: "5", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070023": {
    text: [
      { text: "^", style: { top: "30%", fontSize: "1.2em" } },
      { text: "6", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070024": {
    text: [
      { text: "&", style: { top: "30%", fontSize: "1.2em" } },
      { text: "7", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070025": {
    text: [
      { text: "*", style: { top: "30%", fontSize: "1.2em" } },
      { text: "8", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070026": {
    text: [
      { text: "(", style: { top: "30%", fontSize: "1.2em" } },
      { text: "9", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070027": {
    text: [
      { text: ")", style: { top: "30%", fontSize: "1.2em" } },
      { text: "0", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070028": { text: [{ text: "Enter", style: { top: "50%" } }] },
  "#00070029": { text: [{ text: "Esc", style: { top: "50%" } }] },
  "#0007002A": {
    text: [{ text: "Backspace", style: { top: "50%" } }],
  },
  "#0007002B": {
    text: [{ text: "Tab", style: { top: "50%" } }],
  },
  "#0007002C": {
    text: [{ text: "Space", style: { top: "50%" } }],
  },
  "#0007002D": {
    text: [
      { text: "_", style: { top: "15%", fontSize: "1.4em" } },
      { text: "-", style: { top: "60%", fontSize: "1.4em" } },
    ],
  },
  "#0007002E": {
    text: [
      { text: "+", style: { top: "30%", fontSize: "1.4em" } },
      { text: "=", style: { top: "65%", fontSize: "1.4em" } },
    ],
  },
  "#0007002F": {
    text: [
      { text: "{", style: { top: "25%", fontSize: "1.3em" } },
      { text: "[", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070030": {
    text: [
      { text: "}", style: { top: "25%", fontSize: "1.3em" } },
      { text: "]", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070031": {
    text: [
      { text: "|", style: { top: "25%", fontSize: "1.3em" } },
      { text: "\\", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070033": {
    text: [
      { text: ":", style: { top: "25%", fontSize: "1.4em" } },
      { text: ";", style: { top: "65%", fontSize: "1.4em" } },
    ],
  },
  "#00070034": {
    text: [
      { text: '"', style: { top: "30%", fontSize: "1.4em" } },
      { text: "'", style: { top: "75%", fontSize: "1.4em" } },
    ],
  },
  "#00070035": {
    text: [
      { text: "~", style: { top: "30%", fontSize: "1.7em" } },
      { text: "`", style: { top: "90%", fontSize: "1.7em" } },
    ],
  },
  "#00070036": {
    text: [
      { text: "<", style: { top: "25%", fontSize: "1.8em" } },
      { text: ",", style: { top: "60%", fontSize: "1.3em" } },
    ],
  },
  "#00070037": {
    text: [
      { text: ">", style: { top: "25%", fontSize: "1.8em" } },
      { text: ".", style: { top: "60%", fontSize: "1.3em" } },
    ],
  },
  "#00070038": {
    text: [
      { text: "?", style: { top: "25%", fontSize: "1.5em" } },
      { text: "/", style: { top: "70%", fontSize: "1.4em" } },
    ],
  },
  "#00070039": {
    text: [
      { text: "Caps", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#0007003A": { text: [{ text: "F1", style: { top: "50%" } }] },
  "#0007003B": { text: [{ text: "F2", style: { top: "50%" } }] },
  "#0007003C": { text: [{ text: "F3", style: { top: "50%" } }] },
  "#0007003D": { text: [{ text: "F4", style: { top: "50%" } }] },
  "#0007003E": { text: [{ text: "F5", style: { top: "50%" } }] },
  "#0007003F": { text: [{ text: "F6", style: { top: "50%" } }] },
  "#00070040": { text: [{ text: "F7", style: { top: "50%" } }] },
  "#00070041": { text: [{ text: "F8", style: { top: "50%" } }] },
  "#00070042": { text: [{ text: "F9", style: { top: "50%" } }] },
  "#00070043": { text: [{ text: "F10", style: { top: "50%" } }] },
  "#00070044": { text: [{ text: "F11", style: { top: "50%" } }] },
  "#00070045": { text: [{ text: "F12", style: { top: "50%" } }] },
  "#00070046": {
    text: [
      { text: "Print", style: { top: "35%" } },
      { text: "Screen", style: { top: "65%" } },
    ],
  },
  "#00070047": {
    text: [
      { text: "Scroll", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#00070048": {
    text: [{ text: "Pause", style: { top: "50%" } }],
  },
  "#00070049": {
    text: [{ text: "Insert", style: { top: "50%" } }],
  },
  "#0007004A": {
    text: [{ text: "Home", style: { top: "50%" } }],
  },
  "#0007004B": {
    text: [
      { text: "Page", style: { top: "35%" } },
      { text: "Up", style: { top: "65%" } },
    ],
  },
  "#0007004C": {
    text: [{ text: "Delete", style: { top: "50%" } }],
  },
  "#0007004D": {
    text: [{ text: "End", style: { top: "50%" } }],
  },
  "#0007004E": {
    text: [
      { text: "Page", style: { top: "35%" } },
      { text: "Down", style: { top: "65%" } },
    ],
  },
  "#0007004F": {
    text: [{ text: "→", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070050": {
    text: [{ text: "←", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070051": {
    text: [{ text: "↓", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070052": {
    text: [{ text: "↑", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070053": {
    text: [
      { text: "Num", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#00070054": {
    text: [{ text: "/", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070055": {
    text: [{ text: "*", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070056": {
    text: [{ text: "-", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070057": {
    text: [{ text: "+", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070058": {
    text: [{ text: "Enter", style: { top: "50%" } }],
  },
  "#00070059": {
    text: [{ text: "1", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005A": {
    text: [{ text: "2", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005B": {
    text: [{ text: "3", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005C": {
    text: [{ text: "4", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005D": {
    text: [{ text: "5", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005E": {
    text: [{ text: "6", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005F": {
    text: [{ text: "7", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070060": {
    text: [{ text: "8", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070061": {
    text: [{ text: "9", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070062": {
    text: [{ text: "0", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070063": {
    text: [{ text: ".", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070065": {
    text: [{ text: "Menu", style: { top: "50%" } }],
  },
  "#000700E0": {
    text: [
      { text: "Ctrl", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E1": {
    text: [
      { text: "Shift", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E2": {
    text: [
      { text: "Alt", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E3": {
    text: [{ text: "Code", style: { top: "50%" } }],
  },
  "#000700E4": {
    text: [
      { text: "Ctrl", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E5": {
    text: [
      { text: "Shift", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E6": {
    text: [
      { text: "Alt", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E7": {
    text: [{ text: "Code", style: { top: "50%" } }],
  },

  "#000C00E2": {
    text: [{ text: "Mute", style: { top: "50%" } }],
  },
  "#000C00E9": {
    text: [{ text: "VolUp", style: { top: "50%" } }],
  },
  "#000C00EA": {
    text: [{ text: "VolDn", style: { top: "50%" } }],
  },
  "#000C00B6": {
    text: [{ text: "|◀", style: { top: "50%" } }],
  },
  "#000C00B5": {
    text: [{ text: "▶|", style: { top: "50%" } }],
  },
  "#000C00CD": {
    text: [{ text: "▶ / ‖", style: { top: "50%" } }],
  },

  "#00920106": {
    text: [{ text: "BT_1", style: { top: "50%" } }],
  },
  "#00920107": {
    text: [{ text: "BT_2", style: { top: "50%" } }],
  },
  "#00920108": {
    text: [{ text: "BT_3", style: { top: "50%" } }],
  },
  "#00920130": {
    text: [
      {
        text: "2.4G",
        style: { top: "50%" },
      },
    ],
  },
  "#00920922": {
    text: [
      { text: "Win/", style: { top: "35%" } },
      { text: "Mac", style: { top: "65%" } },
    ],
  },
  "#00900001": {
    text: [{ text: "Esc `", style: { top: "50%" } }],
  },
  "#00921300": {
    text: [
      { text: "Add", style: { top: "35%" } },
      { text: "Touch Sen", style: { top: "65%", fontSize: "0.66em" } },
    ],
  },
  "#00920A02": {
    text: [{ text: "Reset", style: { top: "50%" } }],
  },
  "#00920900": {
    text: [
      { text: "Next", style: { top: "35%" } },
      { text: "LED", style: { top: "65%" } },
    ],
  },
  "#00920901": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Light+", style: { top: "65%" } },
    ],
  },
  "#00920902": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Light-", style: { top: "65%" } },
    ],
  },
  "#00920903": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "On/Off", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#00920904": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Speed+", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#00920905": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Speed-", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090B": {
    text: [
      { text: "Nameplate", style: { top: "35%", fontSize: "0.66em" } },
      { text: "Light+", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090C": {
    text: [
      { text: "Nameplate", style: { top: "35%", fontSize: "0.66em" } },
      { text: "Light-", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090D": {
    text: [
      { text: "Nameplate", style: { top: "35%", fontSize: "0.66em" } },
      { text: "On/Off", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090E": {
    text: [
      { text: "Nameplate", style: { top: "35%", fontSize: "0.66em" } },
      { text: "Color", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090F": {
    text: [
      { text: "Next", style: { top: "35%" } },
      { text: "Nameplate", style: { top: "65%", fontSize: "0.66em" } },
    ],
  },
  "#00920910": {
    text: [{ text: "Battery", style: { top: "50%" } }],
  },
  "#00920C0F": {
    text: [{ text: "Layer1", style: { top: "50%" } }],
  },
  "#00920C10": {
    text: [{ text: "Layer2", style: { top: "50%" } }],
  },
  "#00920C11": {
    text: [{ text: "Layer3", style: { top: "50%" } }],
  },
  "#00920C12": {
    text: [{ text: "Layer4", style: { top: "50%" } }],
  },
  "#00920C13": {
    text: [{ text: "Layer5", style: { top: "50%" } }],
  },
  "#00920C14": {
    text: [{ text: "Layer6", style: { top: "50%" } }],
  },
  "#00920C15": {
    text: [{ text: "Layer7", style: { top: "50%" } }],
  },
  "#00920C20": {
    text: [{ text: "Fn1", style: { top: "50%" } }],
  },
  "#00920C0B": {
    text: [{ text: "Fn2", style: { top: "50%" } }],
  },
  "#00920C22": {
    text: [{ text: "Fn3", style: { top: "50%" } }],
  },
  "#00920C23": {
    text: [{ text: "Fn4", style: { top: "50%" } }],
  },
  "#00920C24": {
    text: [{ text: "Fn5", style: { top: "50%" } }],
  },
  "#00920C25": {
    text: [{ text: "Fn6", style: { top: "50%" } }],
  },
  "#00920C26": {
    text: [{ text: "Fn7", style: { top: "50%" } }],
  },
  "#00910010": {
    text: [{ text: "S Fn1", style: { top: "50%" } }],
  },
  "#00910011": {
    text: [{ text: "S Fn2", style: { top: "50%" } }],
  },
  "#00910012": {
    text: [{ text: "S Fn3", style: { top: "50%" } }],
  },
  "#00910013": {
    text: [{ text: "S Fn4", style: { top: "50%" } }],
  },
  "#00910014": {
    text: [{ text: "S Fn5", style: { top: "50%" } }],
  },
  "#00910015": {
    text: [{ text: "S Fn6", style: { top: "50%" } }],
  },
  "#00910016": {
    text: [{ text: "S Fn7", style: { top: "50%" } }],
  },
};
